import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ProductCard from '../components/ProductCard';
import { products } from '../data/products';

const Products = () => {
  const [stockStatus, setStockStatus] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/stock-status`)
      .then(r => r.json())
      .then(data => setStockStatus(data))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-sm uppercase tracking-wide text-muted-foreground mb-4"></p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tighter mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Shop Our Honey
          </h1>
          <p className="text-base md:text-lg text-foreground/70 max-w-2xl mx-auto leading-relaxed">
            Three unique, single-origin honeys from Victoria. Each with its own character, taste and story.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-testid="products-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} stockInfo={stockStatus[product.name]} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
